import { FullWidthSpace } from "melco-ui";
import {
  ControlcenterMelcoControlCenterModelsUserSerialNumberResponse,
  useFormSubmit,
} from "melco-shared-logic";
import { useQueryClient } from "react-query";
import { Formik, FormikHelpers } from "formik";
import { DirtyFormPrompt } from "../../../form/DirtyFormPrompt";
import { useLicenseManagerChangeLevel } from "../../../../hooks/licensemanager/useLicenseManagerChangeLevel";
import { useState } from "react";
import { DisplayChangeLevelLicenseLevel } from "./DisplayChangeLevelLicenseLevel";
import { NewSelectedValuesForLicenseChangeLevel } from "../../drawer/ChangeLevelLicenseDrawer";
import dayjs from "dayjs";
import { formatUTCDate } from "../../../../helper/dateHelper";

type ChangeLevelLicenseLevelProps = {
  callbackFn: (
    obj: NewSelectedValuesForLicenseChangeLevel,
    license:
      | ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
      | undefined
  ) => void;
  stepback: () => void;
  currentLicense:
  | ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
  | undefined;
};

export const ChangeLevelLicenseLevel: React.FC<
  ChangeLevelLicenseLevelProps
> = ({ currentLicense, stepback, callbackFn }) => {
  const queryClient = useQueryClient();
  const queryKey = "changelevel-querylicensemanage";
  // if (currentLicense && currentLicense.renewal_date) {
  //   currentLicense.renewal_date = undefined
  //   currentLicense.subscription_start_date = dayjs("2025-10-27").toDate()
  // }
  // const { t } = useTranslation();

  const changelevelLicenseAndSendEmail = useLicenseManagerChangeLevel();
  const initialValues = {
    subscription_code: "",
    subscription_start_date: currentLicense?.renewal_date
      ? dayjs(formatUTCDate(currentLicense?.renewal_date)).startOf("day").toDate()
      : currentLicense?.subscription_start_date ? dayjs(formatUTCDate(currentLicense?.subscription_start_date)).startOf("day").toDate()
        : null,
  }
  console.log("initialValue ", JSON.stringify(initialValues))
  const [displayValues, setDisplayValues] = useState({
    // new_version_id_display_value: "",
    new_subscription_code_display_value: "",
  });

  const callBackForSubscriptionCodeDisplayValue = (v: any) => {
    setDisplayValues({
      ...displayValues,
      new_subscription_code_display_value: v,
    });
  };

  const handleChangeLevelLicense = async (
    values: any,
    formikHelpers: FormikHelpers<any>,
    options: {}
  ) => {
    //   //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
    let newEntity:
      | ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
      | undefined = await changelevelLicenseAndSendEmail({
        step: 2,
        serial_number: currentLicense?.serial_number ?? "",
        subscription_code: values.subscription_code,
        melco_customer_id: currentLicense?.melco_customer_id ?? "",
        language: currentLicense?.language ?? "",
        subscription_start_date: values?.subscription_start_date ?? null,
      });

    callbackFn(
      {
        new_subscription_code: values?.subscription_code ?? "",
        new_subscription_code_display_value:
          displayValues.new_subscription_code_display_value,
        subscription_start_date: values?.subscription_start_date ?? null,
      },
      newEntity
    );
  };
  const onSubmit = async (values: any, formikHelpers: FormikHelpers<any>) => {
    await onChangeLevelSerialNumber(values, formikHelpers, {});
  };

  const formSubmitToChangeLevelLicense = () => {
    return [
      async (values: any, formikHelpers: FormikHelpers<any>) => {
        return handleChangeLevelLicense(values, formikHelpers, {});
      },
      {
        //  translationPrefix: "licenses.basic.detail.ChangeLevel",
        // translationOptions: {
        //   batchnumber: 1,
        //        },
        translationPrefix: ["licenses.basic.detail", "changelevel"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onChangeLevelSerialNumber = useFormSubmit(
    ...formSubmitToChangeLevelLicense()
  );

  return (
    <FullWidthSpace direction="vertical" size="large">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <div>
          <DirtyFormPrompt>
            <DisplayChangeLevelLicenseLevel
              currentLicense={currentLicense}
              stepback={stepback}
              callBackForSubscriptionCodeDisplayValue={
                callBackForSubscriptionCodeDisplayValue
              }
            />
          </DirtyFormPrompt>
        </div>
      </Formik>
    </FullWidthSpace>
  );
};
